import { HttpService } from "../../modules/shared/services/http.service";
import { 
  RegionalPricing, 
  CreateRegionalPricingDto, 
  UpdateRegionalPricingDto,
  RegionalPricingResponse,
  RegionalPricingBulkCreateDto,
  RegionalPricingBulkUpdateDto
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Regional Pricing CRUD Functions
export const createRegionalPricing = async (data: CreateRegionalPricingDto): Promise<RegionalPricing> => {
  const response = await HttpService.post("api/v1/regional-pricings", data, headers, true);
  return response;
};

export const updateRegionalPricing = async (id: string, data: UpdateRegionalPricingDto): Promise<RegionalPricing> => {
  const response = await HttpService.patch(`api/v1/regional-pricings/${id}`, data, headers, true);
  return response;
};

export const getRegionalPricingById = async (id: string): Promise<RegionalPricing> => {
  const response = await HttpService.get(`api/v1/regional-pricings/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

export const getRegionalPricings = async (query?: Record<string, string | number | boolean>): Promise<RegionalPricingResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/regional-pricings${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

export const deleteRegionalPricing = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/regional-pricings/${id}`, { "x-custom-lang": "en" }, true);
};

export const bulkCreateRegionalPricings = async (data: RegionalPricingBulkCreateDto): Promise<RegionalPricing[]> => {
  const response = await HttpService.post("api/v1/regional-pricings/bulk", data, headers, true);
  return response;
};

export const bulkUpdateRegionalPricings = async (data: RegionalPricingBulkUpdateDto): Promise<RegionalPricing[]> => {
  const response = await HttpService.patch("api/v1/regional-pricings/bulk", data, headers, true);
  return response;
};

export const bulkDeleteRegionalPricings = async (ids: string[]): Promise<void> => {
  await HttpService.deleteWithData("api/v1/regional-pricings/bulk", { ids }, { "x-custom-lang": "en" }, true);
};
